/**
 * 디자인 토큰 — 색상 (v2 Stitch: 화이트/슬레이트 + #FF6B00, 2026-09-21)
 * 변수명·키는 Concept A 그대로 유지하고 값만 교체 (index.css :root 와 동시 수정).
 *
 * 단일 소스: src/index.css 의 :root.
 * CSS 변수가 SSOT이고, 이 파일은 TS에서 동일 값을 사용할 때 import 한다.
 * RN 확장 시에는 cssVar 필드는 무시하고 hex 값을 직접 사용한다.
 */

export const colors = {
  // 페이지/프레임 — v2 (Stitch) 화이트/슬레이트 (2026-09-21)
  canvas: '#F8FAFC',        // 페이지 배경
  frame: '#FFFFFF',         // 프레임/카드 배경
  surface: '#F1F5F9',       // 떠보이는 면 · 입력
  sunk: '#F1F5F9',          // 들어간 면 / 입력 배경

  // 텍스트 4단계
  ink: '#0F172A',           // 제목
  body: '#334155',          // 본문
  muted: '#64748B',         // 보조
  mute2: '#94A3B8',         // 캡션 / 비활성 아이콘
  mute3: '#CBD5E1',         // 매우 옅은 라벨

  // 보더 3단계
  line: '#E2E8F0',          // 기본 경계
  lineStrong: '#CBD5E1',    // 강한 경계
  lineSoft: '#F1F5F9',      // 옅은 구분선

  // 이미지 fallback
  block: '#E8EDF3',

  // 액센트 — 부냥 오렌지 (Stitch)
  accent: '#FF6B00',
  accentDark: '#EA580C',
  accent50: '#FFF7ED',
  accentSoft: '#FFF7ED',
  accentLine: '#FFD9BE',

  // 시맨틱
  ok: '#10B981',
  warn: '#854D0E',
  warnBg: '#FEF08A',
  bad: '#EF4444',
  info: '#2563EB',

  // v2 신규
  violet: '#7C3AED',        // 입지 '호재' 아이콘 전용
  violetSoft: '#F5F3FF',
  reopen: '#0284C7',        // 지도 '재오픈예정' 마커 전용(2026-09-28 대표 "파란색") — 임대 파랑(info)과 구분

  // 정책 강제용 inverse
  inverseFg: '#FFFFFF',
} as const;

export type ColorToken = keyof typeof colors;

/**
 * CSS 변수명 매핑 (--ca-* 네임스페이스).
 * 컴포넌트에서 `var(--ca-canvas)` 처럼 직접 사용할 때 참조.
 */
export const colorVars = {
  canvas: 'var(--ca-canvas)',
  frame: 'var(--ca-frame)',
  surface: 'var(--ca-surface)',
  ink: 'var(--ca-ink)',
  body: 'var(--ca-body)',
  muted: 'var(--ca-muted)',
  mute2: 'var(--ca-mute2)',
  mute3: 'var(--ca-mute3)',
  line: 'var(--ca-line)',
  lineStrong: 'var(--ca-line-strong)',
  lineSoft: 'var(--ca-line-soft)',
  block: 'var(--ca-block)',
  accent: 'var(--ca-accent)',
  accentDark: 'var(--ca-accent-dark)',
  accent50: 'var(--ca-accent-50)',
  accentSoft: 'var(--ca-accent-soft)',
  accentLine: 'var(--ca-accent-line)',
  ok: 'var(--ca-ok)',
  warn: 'var(--ca-warn)',
  warnBg: 'var(--ca-warn-bg)',
  bad: 'var(--ca-bad)',
  info: 'var(--ca-info)',
  violet: 'var(--v2-violet)',
  violetSoft: 'var(--v2-violet-soft)',
  inverseFg: '#FFFFFF',
} as const;
